import React from 'react'
import { FaCalendarAlt, FaMedal, FaTrophy } from 'react-icons/fa'

export default function AllActivities(props) {

    const { graph } = props

    return (
        <div className="widget widget-table-one">
            <div className="widget-header dash_head">
                <h5>All Activities</h5>
            </div>

            <div className="widget-content mt-3">

                <div className="weekly-bestsellers">
                    <div className="t-company-name d-flex justify-content-between">
                        <div className="t-name">
                            <h6>Hours spent</h6>
                            <p className="meta-date">{graph && graph.total_hours ? graph.total_hours : '-'}</p>
                        </div>
                        <div className="t-icon">
                            <div className="image-container">
                                <FaCalendarAlt />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="weekly-bestsellers">
                    <div className="t-company-name d-flex justify-content-between">
                        <div className="t-name">
                            <h6>Overall result</h6>
                            <p className="meta-date">{graph && graph.overall_result}</p>
                        </div>
                        <div className="t-icon">
                            <div className="image-container">
                                <FaTrophy />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="weekly-bestsellers">
                    <div className="t-company-name d-flex justify-content-between">
                        <div className="t-name">
                            <h6>Completed</h6>
                            <p className="meta-date">{graph && graph.completed}</p>
                        </div>
                        <div className="t-icon">
                            <div className="image-container">
                                <FaMedal />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}
